import './ClientRewardsTermsExpired.scss'

import React, {Component} from 'react'

class ClientRewardsTermsExpired extends Component {

  render() {

    return (
      <div className="ClientRewardsTermsExpired">
        <div className="Dashboard">
          <div className="Dashboard__header">
            <div className="Dashboard__logo"><span className="Dashboard__op">OP</span>CITY</div>
          </div>
        </div>
        <div className="ClientRewardsTermsExpired__content">
          <div className="ClientRewardsTermsExpired__title">Expired Terms</div>
          <div className="ClientRewardsTermsExpired__text">This link has expired. Please contact <a href="mailto:support@opcity.com">support@opcity.com</a> for assistance.</div>
        </div>
      </div>
    )
  }
}

export default ClientRewardsTermsExpired
